import React from 'react';
import Layer1 from '../layers/Layer1';
import Layer2 from '../layers/Layer2';
import AllSpacesList from '../layers/Layer3/AllSpacesList';
import Layer4 from '../layers/Layer4';
import './index.scss';

const AllSpaceResults = () => {
  return (
    <div className="ui-main location">
      <Layer1 />
      <Layer2 context="Space" />
      <AllSpacesList />
      <Layer4 />
    </div>
  );
};

export default AllSpaceResults;
